<template>
  <div class="modal fade slide-right" id="confirmModal" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
      <div class="modal-dialog modal-sm modal-confirm">
          <div class="modal-content-wrapper">
              <div class="modal-content">
                  <div class="modal-header clearfix text-left">
                      <button type="button" class="close" aria-hidden="true" @click="$emit('cancel')">
                        <i class="pg-close fs-14"></i>
                      </button>
                      <div class="col-md-12 modal-left">
                          <h3 class="modal-title">Attention !</h3>
                      </div>
                  </div>
                  <div class="modal-body"  >
                    <div class="col-md-12 modal-right" v-if="isContractValidationRequest">
                      <p>Le statut de paiement de la commande est "{{ order.decoded_payment_status }}".</p>
                      <p>Etes-vous certain de vouloir tout de même valider cette demande (et procéder au déversement dans SAP) ?</p>
                    </div>
                    <div class="col-md-12 modal-right" v-else>
                      <p>Vous êtes sur le point de valider une demande de validation.</p>
                      <p>L'opération est irréversible, êtes-vous certain de vouloir valider cette demande ?</p>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" 
                      class="btn btn-complete btn-cons no-margin inline" 
                      @click="$emit('confirm')"
                      :disabled="buttonsDisabled"
                    >
                      Confirmer
                    </button>
                    
                    <button type="button" 
                      class="btn btn-default btn-cons no-margin inline pull-right"
                      data-dismiss="modal" 
                      @click="$emit('cancel')"
                      :disabled="buttonsDisabled"
                    >
                      Annuler
                    </button>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {mapActions} from 'vuex'
  import cookies from 'cookiesjs'

    export default {

      name: 'Step5Modal',

      props: [
        "order",
        "isContractValidationRequest",
        "buttonsDisabled"
      ],

      mounted () {
          $(this.$el).modal()
      },

      beforeDestroy () {
          $(this.$el).modal('hide')
          $('body').removeClass('modal-open')
          $('.modal-backdrop').remove()
      },

    }
</script>

<style lang="css">
@media (min-width: 768px) {
  .modal-confirm {
    width:340px;
  }
}
</style>



// WEBPACK FOOTER //
// client/components/Demands/Step5Modal.vue